<template>
  <div v-if="location">
    <ModalEditSearchTerm
      v-if="showEditLocationData"
      :showModal="showEditLocationData"
      :onClickCancel="hideModal"
    />

    <ui-section-header
      :showEdit="true"
      :editFunction="setShowEditLocationData"
    >
      <template v-slot:title>Search terms</template>
    </ui-section-header>

    <table class="table is-narrow is-fullwidth">
      <tbody>
        <tr>
          <td>Search term</td>
          <td class="has-text-right">{{ location.Alt }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const ModalEditSearchTerm = () =>
  import('@/components/Locations/ModalEditSearchTerm')

export default {
  components: {
    ModalEditSearchTerm,
  },

  props: {},

  data() {
    return {
      showEditLocationData: false,
    }
  },

  computed: {
    ...mapState('locationStore', ['location', 'locationState']),
  },

  created() { },

  methods: {
    setShowEditLocationData() {
      this.showEditLocationData = true
    },

    hideModal() {
      this.showEditLocationData = false
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  td {
    &:nth-child(2) {
      line-break: anywhere;
    }
  }
}

@media screen and (max-width: 1280px) {
  .table {
    td {
      display: block;
      text-align: left !important;
      &:nth-child(1) {
        border-bottom: 0;
        font-size: 7;
        &::after {
          content: ":";
        }
      }
    }
  }
}
</style>
